module.exports = __webpack_public_path__ + "media/images/brand/img-jewelry1-7e05b8c343323ed60612ffa5e5a5d099.png";